import { render, staticRenderFns } from "./rating-icons.vue?vue&type=template&id=744e8781&scoped=true&lang=pug"
import script from "./rating-icons.vue?vue&type=script&lang=ts"
export * from "./rating-icons.vue?vue&type=script&lang=ts"
import style0 from "./rating-icons.vue?vue&type=style&index=0&id=744e8781&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744e8781",
  null
  
)

export default component.exports